import React, { useCallback } from 'react';

import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';

// import { TeamMembers } from './TeamMembers';
import { AccountDisplayProps, EAccountDisplayState } from '../AccountPanel';
import { TeamMembers } from './TeamMembers';

export const SettingTeam: React.FC<AccountDisplayProps> = ({
	pushDisplayState,
	setOpen,
}): JSX.Element => {
	const fireOpenInviteEvent = useAnalyticsEvent('Account_Team_Open_Invite');
	const navigateToInvite = useCallback(
		() => pushDisplayState(EAccountDisplayState.ADD_TEAM_MEMBER),
		[pushDisplayState],
	);
	const navigateToEditTeamName = useCallback(
		() => pushDisplayState(EAccountDisplayState.EDIT_TEAM_NAME),
		[pushDisplayState],
	);
	const onClose = useCallback(
		() =>
			setOpen({
				open: false,
			}),
		[setOpen],
	);
	return (
		<TeamMembers
			onInviteClick={() => {
				navigateToInvite();
				fireOpenInviteEvent();
			}}
			onEditTeamNameClick={navigateToEditTeamName}
			onClose={onClose}
		/>
	);
};
